import React from 'react'
import { change, show, store, update, success as changeSuccess } from '../../../store/actions/gestor.action'
import { CircularProgress, TextField, AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core'
import { FaSave } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'
import MaskedInput from 'react-text-mask'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [/[0-9]/, /\d/]

    
    if (props.name === 'phone') {
        { /* @ts-ignore */}
        mask = ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length === 15) {
                { /* @ts-ignore */}
                mask = ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function GestorEdit(props) {
    const dispatch = useDispatch()
    const { gestor, error } = useSelector(state => state.gestorReducer)
    const id = (props.uid) ? props.uid : null

    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        if (id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        } else {
            setLoading(false)
        }
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        if(id) {
            dispatch(update(id, gestor))
        } else {
            dispatch(store(gestor))
        }
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Gestor' : 'Novo Gestor'}
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save() }
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Nome</label>
                            <TextField
                                error={(error.name) && true}
                                value={gestor.name || ''}
                                onChange={text => {
                                    dispatch(change({ name: text.target.value }))
                                    if (error.name && delete error.name);
                                }}
                            />

                            {(error.name) &&
                                <strong className="text-danger">{error.name[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Email</label>
                            <TextField
                                error={(error.email) && true}
                                value={gestor.email || ''}
                                onChange={text => {
                                    dispatch(change({ email: text.target.value }))
                                    if (error.email && delete error.email);
                                }}
                            />

                            {(error.email) &&
                                <strong className="text-danger">{error.email[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Telefone</label>
                            <TextField
                                fullWidth
                                error={(error?.telefone) && true}
                                type="tel"
                                name="phone"
                                placeholder="(99) 99999-9999"
                                autoComplete="off"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: gestor?.telefone || '',
                                    onChange: text => {
                                        dispatch(change({ telefone: text.target.value }))
                                        if (error.telefone && delete error.telefone);
                                    }
                                }}
                            />

                            {(error.telefone) &&
                                <strong className="text-danger">{error.telefone[0]}</strong>
                            }
                        </div>

                        {(!id) &&
                        <div className="alert alert-info h6 pb-2 pt-2" role="alert">
                            Informe um whatsapp válido para enviar os dados de acesso.
                        </div>
                        }
                    </div>
                </>
            }
        </div>
    )
}